var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSettingIconSm = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "m7.997.667 6.334 3.666v7.334l-6.334 3.666-6.333-3.666V4.333zm0 1.54-5 2.895v5.796l5 2.895 5-2.895V5.102zm0 8.46a2.667 2.667 0 1 1 0-5.334 2.667 2.667 0 0 1 0 5.334m0-1.334a1.333 1.333 0 1 0 0-2.666 1.333 1.333 0 0 0 0 2.666"
})));
export { SvgSettingIconSm as ReactComponent };
export default __webpack_public_path__ + "9a767b432e5a17516834c6cffd95ad9a.svg";